export const medications = [
  { id: 'M001', name: 'BIREN', category: 'Hypertension', stock: 324, reorder: 100, price: '$12.50', expiry: 'Sep 2025' },
  { id: 'M002', name: 'Metformin', category: 'Diabetes', stock: 158, reorder: 75, price: '$18.25', expiry: 'Aug 2025' },
  { id: 'M003', name: 'Atorvastatin', category: 'Cholesterol', stock: 210, reorder: 80, price: '$25.00', expiry: 'Nov 2025' },
  { id: 'M004', name: 'Amoxicillin', category: 'Antibiotic', stock: 47, reorder: 50, price: '$8.75', expiry: 'Jun 2025' },
  { id: 'M005', name: 'Sertraline', category: 'Antidepressant', stock: 83, reorder: 60, price: '$22.50', expiry: 'Dec 2025' },
];

export const prescriptions = [
  { id: 'P001', patient: 'Sarah Johnson', medication: ['Lisinopril 10mg', 'Atorvastatin 20mg', 'Metformin 500mg','dbbjsdb' , 'djbjsbdjkbjbdbj' , 'bnvbkbvkbkvbd' , 'jjsdbkvbdvbjdfbvjdbvbd' , 'jdbfvjbdfjvbjfb' , 'jkbckjbdskjcjkdbvjkbvkjb' , 'khuyfyegfuyguyfg' , '5rweeuiyuiy'], status: 'Ready', date: 'Apr 7, 2025', doctor: 'Dr. Roberts' },
  { id: 'P002', patient: 'Michael Chen', medication: 'Metformin 500mg', status: 'Processing', date: 'Apr 7, 2025', doctor: 'Dr. Patel' },
  { id: 'P003', patient: 'Emma Wilson', medication: 'Prenatal Vitamins', status: 'Ready', date: 'Apr 6, 2025', doctor: 'Dr. Garcia' },
  { id: 'P004', patient: 'James Rodriguez', medication: 'Atorvastatin 20mg', status: 'Pending', date: 'Apr 7, 2025', doctor: 'Dr. Roberts' },
  { id: 'P005', patient: 'XYZ', medication: 'Atorvastatin 20mg', status: 'Pending', date: 'Apr 8, 2025', doctor: 'Dr. Roberts' },
  { id: 'P006', patient: 'ABC', medication: 'Atorvastatin 20mg', status: 'Pending', date: 'Apr 9, 2025', doctor: 'Dr. Roberts' },
  { id: 'P007', patient: 'PQR', medication: 'Atorvastatin 20mg', status: 'Pending', date: 'Apr 10, 2025', doctor: 'Dr. Roberts' },
  { id: 'P008', patient: 'Kiwi', medication: 'Atorvastatin 20mg', status: 'Pending', date: 'Apr 10, 2025', doctor: 'Dr. Roberts' },
  { id: 'P009', patient: 'Peru', medication: 'Atorvastatin 20mg', status: 'Pending', date: 'Apr 10, 2025', doctor: 'Dr. Roberts' },
  { id: 'P010', patient: 'Fox', medication: 'Atorvastatin 20mg', status: 'Pending', date: 'Apr 10, 2025', doctor: 'Dr. Roberts' },
  { id: 'P011', patient: 'xoxo', medication: 'Atorvastatin 20mg', status: 'Pending', date: 'Apr 10, 2025', doctor: 'Dr. Roberts' },
  { id: 'P012', patient: 'coco', medication: 'Atorvastatin 20mg', status: 'Pending', date: 'Apr 10, 2025', doctor: 'Dr. Roberts' },
];

export const orders = [
  { id: 'ORD001', supplier: 'MediCorp', items: 8, date: 'Apr 10, 2025', status: 'Processing', total: '$245.75' },
  { id: 'ORD002', supplier: 'PharmaPlus', items: 5, date: 'Apr 5, 2025', status: 'Shipped', total: '$189.50' },
  { id: 'ORD003', supplier: 'Global Pharma', items: 12, date: 'Apr 2, 2025', status: 'Delivered', total: '$420.00' },
  { id: 'ORD004', supplier: 'MediCorp', items: 3, date: 'Mar 28, 2025', status: 'Delivered', total: '$75.25' },
];

export const medicineOptions = [
  { label: 'birengohel 500mg', value: 'birengohel 500mg' },
  { label: 'Ibuprofen 400mg', value: 'Ibuprofen 400mg' },
  { label: 'Amoxicillin 250mg', value: 'Amoxicillin 250mg' },
  { label: 'Ciprofloxacin 500mg', value: 'Ciprofloxacin 500mg' },
  { label: 'Azithromycin 250mg', value: 'Azithromycin 250mg' },
  { label: 'Metformin 500mg', value: 'Metformin 500mg' },
  { label: 'Atorvastatin 10mg', value: 'Atorvastatin 10mg' },
  { label: 'Pantoprazole 40mg', value: 'Pantoprazole 40mg' },
  { label: 'Losartan 50mg', value: 'Losartan 50mg' },
  { label: 'Cetirizine 10mg', value: 'Cetirizine 10mg' },
]; 


export const pastHistory = [
  { id: 'H001', patientId: 'P001', patient: 'John Doe', date: '2025-05-01', time: '10:30 AM', reason: 'Fever and cough' },
  { id: 'H002', patientId: 'P001', patient: 'John Doe', date: '2025-04-15', time: '03:00 PM', reason: 'Headache and fatigue' },
  { id: 'H003', patientId: 'P002', patient: 'Jane Smith', date: '2025-04-10', time: '09:00 AM', reason: 'Back pain' },
];

export const inventoryData = [
  { id: 'M001', name: 'Paracetamol', quantity: 120, supplier: 'ABC Pharma' },
  { id: 'M002', name: 'Ibuprofen', quantity: 80, supplier: 'XYZ Pharma' },
];

export const prescriptionAnalyticsData = [
  { medicine: 'Paracetamol', prescribed: 200 },
  { medicine: 'Ibuprofen', prescribed: 150 },
  { medicine: 'Ib', prescribed: 150 },
  { medicine: 'Idfgdfgbprofen', prescribed: 150 },
  { medicine: 'Ibupyutyen', prescribed: 150 },
  { medicine: 'uyuiybuprofen', prescribed: 150 },
  { medicine: 'kjdbkjcprofen', prescribed: 150 },
  { medicine: 'Ibuprokdgjchasden', prescribed: 150 },
  { medicine: 'Ibuprofkdjn', prescribed: 150 },
  { medicine: 'Ibdfbfgbuprofen', prescribed: 150 },
  { medicine: 'oofjlbuprofen', prescribed: 150 },
  { medicine: 'qqqqbuprofen', prescribed: 150 },
  { medicine: 'jhjhjhjuprofen', prescribed: 150 },
  { medicine: 'bncncnuprofen', prescribed: 150 },
  { medicine: 'kjklkfklduprofen', prescribed: 150 },
  { medicine: 'mxbcnbnmbuprofen', prescribed: 150 },
  { medicine: 'nnbnbvuprofen', prescribed: 150 },
  { medicine: 'dbcbnuprofen', prescribed: 150 },
  { medicine: 'Ibjhfhagprofen', prescribed: 150 },
  { medicine: 'Ibkjgjhchprofen', prescribed: 150 },
  { medicine: 'wbuprofen', prescribed: 150 },
  { medicine: 'rbuprofen', prescribed: 150 },
  { medicine: 'fdbuprofen', prescribed: 150 },
  { medicine: 'lbuprofen', prescribed: 150 },
  { medicine: 'mbuprofen', prescribed: 150 },
  { medicine: 'jbuprofen', prescribed: 150 },
  { medicine: 'dbuprofen', prescribed: 150 },
  { medicine: 'abuprofen', prescribed: 150 },
  { medicine: 'zbuprofen', prescribed: 150 },
  { medicine: 'sdbuprofen', prescribed: 150 },
  { medicine: 'jhsdfgjhsdgbuprofen', prescribed: 150 },
  { medicine: 'kjsabhxBbuprofen', prescribed: 150 },
];

export const financialSummaryData = [
  { month: 'April', income: 15000, expense: 8000, profit: 7000 },
  { month: 'May', income: 18000, expense: 9000, profit: 9000 },
];

export const financials = [
  { id: 'F001', date: '2025-06-01', description: 'Medicine Sale', amount: 3500 },
  { id: 'F002', date: '2025-06-02', description: 'Supplier Payment', amount: -2000 },
  { id: 'F003', date: '2025-06-03', description: 'Consultation Fee', amount: 1500 },
  // more entries...
];